import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '../../definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'risk-profil-fourth-part-form',
    templateUrl: './risk-profil-fourth-part-form.component.html',
    styleUrls: ['./risk-profil-fourth-part-form.component.scss'],
    standalone: false
})
export class RiskProfilFourthPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    {
      value: 'LOWER_THAN_100K',
      label: 'Inférieur à 100k€',
      suffix: { title: 'A' },
    },
    {
      value: 'BETWEEN_100K_AND_300K',
      label: 'Entre 100k et 300k€',
      suffix: { title: 'B' },
    },
    {
      value: 'BETWEEN_300K_AND_500K',
      label: 'Entre 300k et 500k€',
      suffix: { title: 'C' },
    },
    {
      value: 'BETWEEN_500K_AND_1M',
      label: 'Entre 500k€ et 1M€',
      suffix: { title: 'D' },
    },
    {
      value: 'GREATER_THAN_1M',
      label: 'Supérieur à 1M€',
      suffix: { title: 'E' },
    },
  ];
  options2: FormControlOption[] = [
    {
      value: 'LESS_THAN_35K',
      label: 'Inférieur à 35k€',
      suffix: { title: 'A' },
    },
    {
      value: 'BETWEEN_35K_AND_60K',
      label: 'Entre 35k et 60k€',
      suffix: { title: 'B' },
    },
    {
      value: 'BETWEEN_60K_AND_100K',
      label: 'Entre 60k et 100k€',
      suffix: { title: 'C' },
    },
    {
      value: 'BETWEEN_100K_AND_250K',
      label: 'Entre 100k et 250k€',
      suffix: { title: 'D' },
    },
    {
      value: 'GREATER_THAN_250K',
      label: 'Supérieur à 250k€',
      suffix: { title: 'E' },
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
